/* Size guide modal — shared by both PDPs.
 *
 * The "Size chart" link used to scroll to the inline guide on desktop and follow
 * its href to /pages/size-guide on mobile. It now opens a modal on both, which is
 * what Simon asked for (2026-08-22), and the modal borrows the inline guide's own
 * markup rather than carrying a second copy of the tables.
 *
 * Delegated document-level singleton per CONVENTIONS section 7, so it survives the
 * theme editor swapping a section's DOM.
 */
(function () {
  if (window.__cvSizeModal) return;
  window.__cvSizeModal = true;

  var LINKS = '[data-cv-pdpd-sizechart-scroll], [data-cv-pdpi-sizechart]';
  var lastFocus = null;

  function modal() { return document.querySelector('[data-cv-size-modal]'); }

  function guideFor(link) {
    // the guide that belongs to THIS product section, not the first on the page
    var root = link.closest('[data-cv-pdpd-root], [data-cv-pdpi-root], .cv-pdpd, .cv-pdpi');
    return (root && root.querySelector('#size-guide')) || document.getElementById('size-guide');
  }

  function open(link) {
    var m = modal();
    if (!m) return false;

    var body = m.querySelector('[data-cv-size-modal-body]');
    /* Offer launch 2026-09: the modal shows the size-chart-v2 PAGE (one source
       of truth for sizing) instead of cloning the inline guide. Same-origin
       iframe so the page's own tabs/unit toggles run untouched; its header,
       footer and announcement bar are hidden on load. Falls back to the old
       inline-guide clone only when the link carries no page URL. */
    var url = link.getAttribute('href') || '';
    if (url.indexOf('/pages/') !== -1) {
      var frame = body.querySelector('iframe[data-cv-size-frame]');
      if (!frame || frame.getAttribute('data-cv-size-frame') !== url) {
        body.innerHTML = '';
        frame = document.createElement('iframe');
        frame.className = 'cv-size-modal__frame';
        frame.setAttribute('data-cv-size-frame', url);
        frame.setAttribute('title', 'Size chart');
        frame.addEventListener('load', function () {
          try {
            var doc = frame.contentDocument;
            if (!doc || !doc.head) return;
            var st = doc.createElement('style');
            st.textContent = '.shopify-section-group-header-group,.shopify-section-group-footer-group,' +
              '#shopify-section-header,#shopify-section-footer,.cv-hdr,.cv-ftr,header.header,footer.footer,' +
              '.announcement-bar,#shopify-section-announcement-bar{display:none!important}' +
              'body{padding-top:0!important}';
            doc.head.appendChild(st);
          } catch (err) { /* cross-origin only if the URL left the store; nothing to hide then */ }
        });
        frame.src = url;
        body.appendChild(frame);
      }
    } else {
      var guide = guideFor(link);
      if (!guide) return false;
      /* the cloned guide leaves its root's [data-use-inches] CSS scope, so the
         shell mirrors the current unit state (and the unit toggle keeps it in
         sync from then on) */
      var unitRoot = guide.closest('[data-use-inches]');
      if (unitRoot) m.setAttribute('data-use-inches', unitRoot.getAttribute('data-use-inches'));
      var clone = guide.cloneNode(true);
      clone.removeAttribute('id');                       // never duplicate #size-guide
      clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      body.innerHTML = '';
      body.appendChild(clone);
    }

    lastFocus = document.activeElement;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cv-size-modal-lock');
    var panel = m.querySelector('[data-cv-size-modal-panel]');
    if (panel) { panel.scrollTop = 0; panel.focus(); }
    return true;
  }

  function close() {
    var m = modal();
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cv-size-modal-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var link = t.closest(LINKS);
    if (link) {
      if (open(link)) {
        e.preventDefault();
        // stop the PDP scripts' own handler too: it scrolls the page to the inline
        // guide, which would leave the shopper somewhere else when the modal closes
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }
      return;
    }
    if (t.closest('[data-cv-size-modal-close]')) {
      e.preventDefault();
      close();
    }
  }, true);                                            // capture: run before the PDP scripts' own scroll handlers

  document.addEventListener('keydown', function (e) {
    var m = modal();
    if (!m || !m.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    // keep focus inside the panel
    var panel = m.querySelector('[data-cv-size-modal-panel]');
    var focusables = panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) { e.preventDefault(); panel.focus(); return; }
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });
})();
